import { STATUS_STYLES } from "../lib/constants";

export function StatusBadge({ status, testid }) {
  const s = STATUS_STYLES[status] || STATUS_STYLES["Not Started"];
  return (
    <span
      data-testid={testid || `status-badge-${(status || "").toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold tracking-wide border ${s.badge}`}
    >
      <span className="h-2 w-2 rounded-full" style={{ background: s.dot }} />
      {status}
    </span>
  );
}
